import { facebookLogin } from 'app/core/http';
import {
  checkThirdPartyLogin,
  CheckThirdPartyLoginDeps
} from '../checkThirdPartyLogin';
import { triggerThirdPartyLoginFailedMessage } from '../triggerThirdPartyLoginFailedMessage';

export function checkFacebookLogin(deps: CheckThirdPartyLoginDeps) {
  const [surveyConfig] = deps;

  FB.login(({ status, authResponse }) => {
    const token = (authResponse && authResponse.accessToken) || '';

    if (status !== 'connected' || !token) {
      const { wording } = surveyConfig;
      triggerThirdPartyLoginFailedMessage(wording);
    } else {
      checkThirdPartyLogin(
        async () => await facebookLogin(surveyConfig.surveyHash, token),
        deps
      );
    }
  });
}
